<template>
  <div class="row">
    <div class="col-md-10 col-xs-8 text-left">
      <label class="checkbox-label-heading">{{ placeholder }}</label>
    </div>
    <div class="col-md-2 col-xs-4 text-right">
      <div class="toggle-container">
        <label class="toggle-label" :for="`toggle_${value}`">{{ label }}</label>
        <input
          ref="toggle"
          type="checkbox"
          class="toggle"
          v-model="internalChecked"
          @change="handleChange"
          :id="`toggle_${value}`"
        />
        <span class="toggle-new-design" @click="triggerToggle"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: ['value', 'placeholder', 'label'],
  data() {
    return {
      internalChecked: this.value === 'true', // Make sure it's a boolean
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.internalChecked)
    },
    triggerToggle(event) {
      this.internalChecked = !this.internalChecked
      this.handleChange()
    },
  },
}
</script>

<style scoped>
.checkbox-label-heading {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  color: #2e4051;
  margin-bottom: 20px;
  text-transform: capitalize;
}

.toggle-label {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2e4051;
  top: -3px;
  position: relative;
}

.toggle-container {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.toggle {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.toggle-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 34px;
  bottom: 5px;
}

.toggle {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-new-design {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.toggle-new-design:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.toggle:checked ~ .toggle-new-design {
  background-color: #2e4051;
}

.toggle:focus ~ .toggle-new-design {
  box-shadow: 0 0 1px #e0e2e5;
}

.toggle:checked ~ .toggle-new-design:before {
  transform: translateX(26px);
}
</style>
